const REQUEST_FUNDING_SEARCH_OVERVIEW = 'platfi-ui-app/DASHBOARD/REQUEST_FUNDING_SEARCH_OVERVIEW';
const REQUEST_FUNDING_SEARCH_OVERVIEW_SUCCESS =
  'platfi-ui-app/DASHBOARD/REQUEST_FUNDING_SEARCH_OVERVIEW_SUCCESS';
const REQUEST_FUNDING_SEARCH_OVERVIEW_FAILURE =
  'platfi-ui-app/DASHBOARD/REQUEST_FUNDING_SEARCH_OVERVIEW_FAILURE';

export {
  REQUEST_FUNDING_SEARCH_OVERVIEW,
  REQUEST_FUNDING_SEARCH_OVERVIEW_SUCCESS,
  REQUEST_FUNDING_SEARCH_OVERVIEW_FAILURE,
};
